import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import bridge from './utils/bridge'

Vue.config.productionTip = false
Vue.use(Vant)

// 全局挂载 bridge 工具
Vue.prototype.$bridge = bridge
Vue.prototype.$util = bridge

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
